import { format, parse } from 'date-fns';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsTrigger, Button, Card, CardBottom, CardContent, CardTop, GridColumn, IButtonSpanProps, TGridColumnWidth } from 'telia-front-react';
import { DigitarkNewsItem } from '../stores/DigitarkNewsStore';
import LanguageStore from '../stores/LanguageStore';
import { TranslationsContext } from '@teliaee/telia-translate';

interface DigitarkNewsCardProps extends DigitarkNewsItem {
  grid?: TGridColumnWidth[];
  showButton?: boolean;
  showDate?: boolean;
  dateFormat?: string;
  button?: IButtonSpanProps;
  languageStore?: LanguageStore;
}

const DigitarkNewsCard: React.FC<DigitarkNewsCardProps> = (props) => {
  const translate = React.useContext(TranslationsContext).translate;
  return (
    <GridColumn width={props.grid}>
      <AnalyticsTrigger trigger={{ id: `Link - ${props.originalTitle}`, callback: 'onClick' }}>
        <Card url={props.link} image={{ src: props.feedImageUrl, role: 'presentation' }}>
          <CardContent>
            <CardTop>
              <div className="text">
                <h4>{props.originalTitle}</h4>
              </div>
            </CardTop>

            {props.showDate && (
              <div className="text text-small">
                <div className="text__margin">
                  <time dateTime={props.date}>
                    {format(parse(props.date, 'dd.MM.yyyy', Date.now()), props.dateFormat, { locale: props.languageStore.currentLocale })}
                  </time>
                </div>
              </div>
            )}

            {props.showButton && (
              <CardBottom>
                <Button
                  element={'span'}
                  variant="secondary"
                  iconRight="#arrow-right"
                  {...props.button}
                  text={props.button.text || translate('digitarkNewsItem.buttonText')}
                />
              </CardBottom>
            )}
          </CardContent>
        </Card>
      </AnalyticsTrigger>
    </GridColumn>
  );
};

DigitarkNewsCard.defaultProps = {
  showButton: true,
  showDate: true,
  grid: ['xs-12', 'sm-6', 'md-4', 'lg-3'],
  dateFormat: 'd. MMMM yyyy',
  button: {
    text: '',
    element: 'span'
  }
};

export default inject('languageStore')(observer(DigitarkNewsCard));
